// src/scenes/WinScene.ts
//
// Phase 7 — terminal "you won" screen reached after clearing the ante 3 boss
// shop's Skip. Programmer art only (text + rectangles), no emojis.

import Phaser from 'phaser';
import { addCrispText } from '../ui/textHelper';

export class WinScene extends Phaser.Scene {
  private seed = '';

  constructor() {
    super({ key: 'Win' });
  }

  init(data: { seed?: string }): void {
    this.seed = data?.seed ?? '';
  }

  create(): void {
    // Phase 17: navy background + bg-tile overlay
    this.add.rectangle(0, 0, this.scale.width, this.scale.height, 0x0d1b2a).setOrigin(0, 0);
    if (this.textures.exists('bg-tile')) {
      const tileW = 128;
      const tileH = 128;
      const cols = Math.ceil(this.scale.width / tileW) + 1;
      const rows = Math.ceil(this.scale.height / tileH) + 1;
      for (let r = 0; r < rows; r++) {
        for (let c = 0; c < cols; c++) {
          this.add.image(c * tileW, r * tileH, 'bg-tile').setOrigin(0, 0).setAlpha(0.08);
        }
      }
    }

    addCrispText(this, 187, 200, 'YOU WIN', {
      fontFamily: 'system-ui, -apple-system, sans-serif',
      fontSize: '32px',
      color: '#d4af37',
    }).setOrigin(0.5);

    addCrispText(this, 187, 260, 'Beat Ante 3 Boss', {
      fontFamily: 'system-ui, -apple-system, sans-serif',
      fontSize: '14px',
      color: '#ffffff',
    }).setOrigin(0.5);

    addCrispText(this, 187, 290, `Seed: ${this.seed}`, {
      fontFamily: 'system-ui, -apple-system, sans-serif',
      fontSize: '11px',
      color: '#aaaaaa',
    }).setOrigin(0.5);

    const btn = this.add
      .rectangle(187, 400, 200, 40, 0x064020)
      .setInteractive({ useHandCursor: true });
    addCrispText(this, 187, 400, 'New Run', {
      fontFamily: 'system-ui, -apple-system, sans-serif',
      fontSize: '14px',
      color: '#ffffff',
    }).setOrigin(0.5);
    btn.on('pointerdown', () => this.scene.start('MenuScene'));
  }
}
